import { useUserStore } from '@/store/user';
import { useParams } from 'react-router-dom';

export const useUnread = () => {
  const { client } = useParams();

  const { clients } = useUserStore();

  return {
    isSmerUnread:
      clients[client!]?.smerViewed.size < clients[client!]?.smerIds.length,
    isDaybookUnread:
      clients[client!]?.daybooksViewed.size <
      clients[client!]?.daybooksIds.length,
  };
};
